// extracted by mini-css-extract-plugin
export default {"main":"News_main__JXMxq","outer":"News_outer__DSY8m","content":"News_content__kVycf","title":"News_title__eqYv-","description":"News_description__PfKJR"};